<template>
    <div ref="calendarTab" class="flex flex-row gap-4 items-stretch">
        <UserCalendar
            v-if="userDetails?.has_calendar_integration"
            class="w-full min-w-0"
            :initial-calendar-events="initialCalendarEvents"
            :calendar-coach-use-case="calendarCoachUseCase"
            :calendar-insights-enabled="calendarInsightsEnabled"
            @coach-hover="$emit('coach-hover', $event)"
            @coach-hover-end="$emit('coach-hover-end')" />
        <CalendarLockedPreview v-else-if="calendarLockedPreview" class="w-full" />
        <CalendarEmptyState v-else class="w-full" />
    </div>
</template>

<script setup lang="ts">
import type { UserDetails } from "~vue/appTypes";
import CalendarEmptyState from "~vue/ChatHome/CalendarEmptyState.vue";
import CalendarLockedPreview from "~vue/ChatHome/CalendarLockedPreview.vue";
import UserCalendar from "~vue/ChatHome/UserCalendar.vue";
import { returnToCalendarAfterConnect } from "~vue/stores/calendarStore";
import type { CalendarIntegrationViewEvent } from "~vue/types/calendar_integration";
import type { ChatEntranceUseCaseData } from "~vue/types/chat";
import { inject, onMounted, type Ref, useTemplateRef } from "vue";

interface Props {
    initialCalendarEvents: CalendarIntegrationViewEvent[] | null;
    calendarCoachUseCase: ChatEntranceUseCaseData | null;
    calendarInsightsEnabled: boolean;
    calendarLockedPreview?: boolean;
}

withDefaults(defineProps<Props>(), {
    initialCalendarEvents: null,
    calendarCoachUseCase: null,
    calendarInsightsEnabled: false,
    calendarLockedPreview: false,
});

defineEmits<{
    "coach-hover": [useCase: ChatEntranceUseCaseData];
    "coach-hover-end": [];
}>();

const userDetails = inject<Ref<UserDetails>>("user_details");
const calendarTab = useTemplateRef("calendarTab");

onMounted(() => {
    if (returnToCalendarAfterConnect.value && userDetails?.value?.has_calendar_integration) {
        // Tabs mount their contents after the page; wait for their layout before scrolling.
        globalThis.requestAnimationFrame(() => {
            if (calendarTab.value) {
                calendarTab.value.scrollIntoView({ block: "start" });
                returnToCalendarAfterConnect.value = false;
            }
        });
    }
});
</script>
